<template>
  <div>
     <my-popup
      title="保存模板"
      width="370"
      zIndex="3330"
      :flag="keepTmpShow"
      @close="keepTmpChange"
    >
      <div class="selectBox">
        <div class="headCnt">
          <span>选择栏目：</span>
          <el-select
            v-model="keepTmpValue"
            placeholder="请选择"
            style="width: 240px"
          >
            <el-option
              v-for="(item, index) in dirList"
              :key="index"
              :label="item.title"
              :value="item.tid"
            ></el-option>
          </el-select>
        </div>
        <button class="keepBtn" @click="keepTmpChange(1)">保存模板</button>
      </div>
    </my-popup>

  </div>
</template>

<script>
import myPopup from "@/components/myPopup";
import { getTemplateDir } from "@/api/smsTemplates";
export default {
  name: '',
  components: {
    myPopup
  },
  props: {
    keepTmpShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dirList: [],
      keepTmpValue: '',
    }
  },
  mounted() {
      var param = {
        type: 0,
      };
      getTemplateDir(param).then((res) => {
        if (res.code == "1") {
          this.dirList = res.data;
        }
      });
  },
  methods: {
    keepTmpChange(val) {
      var param = {
        flag: val == 1 ? true: false,
        value: this.keepTmpValue
      }
      this.$emit('onClose', param)
    },

  }
}
</script>

<style scoped lang="scss">
  .selectBox {
    text-align: right;
    .headCnt {
      display: flex;
      align-items: center;
      margin-top: 20px;
    }
    .keepBtn {
      width: 98px;
      height: 32px;
      line-height: 30px;
      margin-top: 20px;
      text-align: center;
      background: rgba(254, 77, 69, 1);
      border-radius: 3px;
      color: #fff;
      font-size: 14px;
    }
    button {
      border: none;
      background-color: white;
      outline: none;
      padding: 0;
      margin: 0;
      border-radius: 2px;
    }
  }

</style>